import { render } from "./GeneralCheckbox.vue?vue&type=template&id=67f31e55"
import script from "./GeneralCheckbox.vue?vue&type=script&lang=js"
export * from "./GeneralCheckbox.vue?vue&type=script&lang=js"

import "./GeneralCheckbox.vue?vue&type=style&index=0&id=67f31e55&lang=css"
script.render = render

export default script